import { ref, watchEffect } from 'vue'

const breakpoints = {
  xs: '(max-width: 576px)',
  sm: '(max-width: 768px)',
  md: '(max-width: 992px)',
  lg: '(max-width: 1200px)'
}

export default function useMobile(size) {
  const isMobile = ref(false)

  const mediaQuery = breakpoints[size]

  const updateIsMobile = () => {
    isMobile.value = window.matchMedia(mediaQuery).matches
  }

  watchEffect((onInvalidate) => {
    updateIsMobile()
    const mediaQueryList = window.matchMedia(mediaQuery)
    const listener = (event) => {
      isMobile.value = event.matches
    }

    mediaQueryList.addEventListener('change', listener)

    onInvalidate(() => {
      mediaQueryList.removeEventListener('change', listener)
    })
  })

  return isMobile
}
